import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import Base, { State as BaseState } from './Base'

Vue.use(Vuex)

const state = {
	testingBg: null,
	myProfile: JSON.parse(window.localStorage.getItem('userProfile') as any),
	homeworkProfileName: '',
	modalType: '',
	modalId: [],
	gameConfig: {},
	forGroup: '',
	profiles: [],
	profile: {
		name: '',
		first_name: '',
		last_name: '',
		role: '',
	},
	reportFranchise: {},
	reportStudent: {},
	reportInvoices: {},
	storage: {
		history: [],
		folder: null,
		folders: [],
		files: [],
	},
	feedbackList: [],
	abacus: {
		1: {
			five: false,
			digit: 0,
		},
		10: {
			five: false,
			digit: 0,
		},
		100: {
			five: false,
			digit: 0,
		},
		1000: {
			five: false,
			digit: 0,
		},
		10000: {
			five: false,
			digit: 0,
		},
		100000: {
			five: false,
			digit: 0,
		},
		1000000: {
			five: false,
			digit: 0,
		},
	},
}

export type RootState = typeof state
export type ApplicationState = RootState & {
	Base: BaseState
}

const store: StoreOptions<RootState> = {
	state,
	modules: { Base },
	getters: {
		primaryBackground(state) {
			return state.testingBg || state.myProfile?.background || ''
		},
	},
	mutations: {
		changeTestingBg(state, value) {
			state.testingBg = value
		},
		changeForGroup(state, value) {
			state.forGroup = value
		},
		changeModalType(state, value) {
			state.modalType = value
		},
		changeModalId(state, value) {
			state.modalId = value
		},
		changeProfile(state, value) {
			state.profile = value
		},
		changeProfiles(state, value) {
			state.profiles = value
		},
		changeMyProfile(state, value) {
			state.myProfile = value
		},
		changeReportsFranchise(state, value) {
			state.reportFranchise = value
		},
		changeReportsStudent(state, value) {
			state.reportStudent = value
		},
		changeReportsInvoices(state, value) {
			state.reportInvoices = value
		},
		changeStorageFolders(state, value) {
			state.storage = { ...state.storage, folders: value }
		},
		changeStorageFiles(state, value) {
			state.storage = { ...state.storage, files: value }
		},
		changeStorageFolder(state, value) {
			state.storage = { ...state.storage, folder: value }
		},
		removeStorageData(state, payload) {
			const list = (state.storage as any)[payload.type as any]
			state.storage = {
				...state.storage,
				[payload.type]: [
					...list.slice(0, payload.index),
					...list.slice(payload.index + 1, list.length),
				],
			}
		},
		changeStorageHistory(state, value) {
			const history = state.storage.history
			if (value) {
				;(history as any).push(value as any)
			} else {
				history.pop()
			}
			state.storage = { ...state.storage, history }
		},
		changeFeedbackList(state, value) {
			state.feedbackList = value
		},
		changeGameConfig(state, value) {
			state.gameConfig = value
		},
		resetAbacus(state) {
			state.abacus = {
				1: {
					five: false,
					digit: 0,
				},
				10: {
					five: false,
					digit: 0,
				},
				100: {
					five: false,
					digit: 0,
				},
				1000: {
					five: false,
					digit: 0,
				},
				10000: {
					five: false,
					digit: 0,
				},
				100000: {
					five: false,
					digit: 0,
				},
				1000000: {
					five: false,
					digit: 0,
				},
			}
		},
		updateAbacus(state, newAbacus) {
			state.abacus = newAbacus
		},
	},
}

export default new Vuex.Store<RootState>(store)
